import React, { Component } from "react";
import "./timer.scss";

export default class Timer extends Component {
  state = {
    minutes: this.props.minutes,
    seconds: this.props.seconds,
    fillPercent: 100,
  };
  resetTimer = (timer) => {
    this.setState({
      minutes: timer.minutes,
      seconds: timer.seconds,
    });
  };

  _startCountDown = () => {
    this.myInterval = setInterval(() => {
      if (this.state.minutes === 0 && this.state.seconds === 0) {
        setTimeout(() => {
          this.props.onTimeFinish();
        }, 1000);
      }
      this.props.updateTime(this.state.minutes + ":" + this.state.seconds);
      const { seconds, minutes } = this.state;
      const { minutes: m } = this.props;
      const totalMin = seconds ? seconds / 60 + minutes : minutes;
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
          fillPercent: (totalMin / m) * 100,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
            fillPercent: (totalMin / m) * 100,
          }));
        }
      }
    }, 1000);
  };

  componentDidMount() {
    this._startCountDown();
  }
  componentWillUnmount() {
    clearInterval(this.myInterval);
  }
  render() {
    const { minutes, seconds, fillPercent } = this.state;
    const { level } = this.props;
    return (
      <div className="timer">
        {window?.innerWidth > 1024 ? (
          <div className="fill" style={{ width: fillPercent + "%" }}></div>
        ) : (
          <div className="lvl">Level {level}</div>
        )}
        {minutes === 0 && seconds === 0 ? (
          <h1>Timed out</h1>
        ) : (
          <h1>
            {minutes < 10 ? `0${minutes}` : minutes}:
            {seconds < 10 ? `0${seconds}` : seconds}
          </h1>
        )}
      </div>
    );
  }
}
